function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 22C8.58333 22 8.22917 21.8542 7.9375 21.5625C7.64583 21.2708 7.5 20.9167 7.5 20.5V20C7.08333 20 6.72917 19.8542 6.4375 19.5625C6.14583 19.2708 6 18.9167 6 18.5V7.5C6 7.08333 6.14583 6.72917 6.4375 6.4375C6.72917 6.14583 7.08333 6 7.5 6H9V2.75C9 2.55 9.075 2.375 9.225 2.225C9.375 2.075 9.55 2 9.75 2H14.25C14.45 2 14.625 2.075 14.775 2.225C14.925 2.375 15 2.55 15 2.75V6H16.5C16.9167 6 17.2708 6.14583 17.5625 6.4375C17.8542 6.72917 18 7.08333 18 7.5V18.5C18 18.9167 17.8542 19.2708 17.5625 19.5625C17.2708 19.8542 16.9167 20 16.5 20V20.5C16.5 20.9167 16.3542 21.2708 16.0625 21.5625C15.7708 21.8542 15.4167 22 15 22C14.5833 22 14.2292 21.8542 13.9375 21.5625C13.6458 21.2708 13.5 20.9167 13.5 20.5V20H10.5V20.5C10.5 20.9167 10.3542 21.2708 10.0625 21.5625C9.77083 21.8542 9.41667 22 9 22ZM10.5 6H13.5V3.5H10.5V6ZM7.5 18.5H16.5V7.5H7.5V18.5Z",
  fill: "black"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/luggage-lg.f78d9378.svg";
export { SvgComponent as ReactComponent };